import * as allNewsActions from './actions';
import * as userActions from '../user/actions';
import * as allNewsFiltersActions from '../allNewsFilters/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    limit: 5,
    offset: 0,
    hasMore: true,
    count: 0,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const allNewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case allNewsActions.SET_NEWS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case allNewsActions.SET_NEWS_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case allNewsActions.SET_NEWS:
            const mappedList =
                Array.isArray(action.listNews) && action.listNews.length
                    ? action.listNews.map((item) => ({ ...item, importanceChanged: false }))
                    : [];
            const listNews = state.list ? state.list.concat(mappedList) : mappedList;
            return {
                ...state,
                list: listNews,
                offset: action.offset,
                hasMore: action.hasMore,
                count: action.count,
                isFetching: false,
                isLoaded: true,
            };

        // Categories
        case allNewsFiltersActions.ALL_NEWS_APPLY_SOURCES_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_SOURCES_FROM_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_SOURCES_FILTER:
            return initialState;

        // Categories
        case allNewsFiltersActions.ALL_NEWS_APPLY_CATEGORIES_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_CATEGORY_FROM_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_CATEGORIES_FILTER:
            return initialState;

        // Dates
        case allNewsFiltersActions.ALL_NEWS_APPLY_DATES_RANGE_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_DATES_RANGE_FILTER:
            return initialState;

        // Search
        case allNewsFiltersActions.ALL_NEWS_APPLY_SEARCH_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_SEARCH_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_SEARCH_ITEM:
            return initialState;

        // Additional
        case allNewsFiltersActions.ALL_NEWS_APPLY_ADDITIONAL_FILTER:
            return initialState;

        case allNewsFiltersActions.ALL_NEWS_REMOVE_ADDITIONAL_FILTER:
            return initialState;

        // Company
        case allNewsFiltersActions.ALL_NEWS_REMOVE_COMPANY_FROM_FILTER:
            return initialState;

        // Person
        case allNewsFiltersActions.ALL_NEWS_REMOVE_PERSON_FROM_FILTER:
            return initialState;

        // Region
        case allNewsFiltersActions.ALL_NEWS_REMOVE_REGION_FROM_FILTER:
            return initialState;

        // Source
        case allNewsFiltersActions.ALL_NEWS_REMOVE_SOURCE_FROM_FILTER:
            return initialState;

        // Tonality
        case allNewsFiltersActions.ALL_NEWS_REMOVE_TONALITY_FROM_FILTER:
            return initialState;

        // Subjectivity
        case allNewsFiltersActions.ALL_NEWS_REMOVE_SUBJECTIVITY_FROM_FILTER:
            return initialState;

        // All
        case allNewsFiltersActions.ALL_NEWS_REMOVE_ALL_FILTERS:
            return initialState;

        case allNewsActions.UPDATE_NEWS_FEED_AFTER_RATE_USERACTION:
            const updatedLoadedList =
                state.list &&
                state.list.map((item) => {
                    if (item.id === +action.articleId) {
                        return {
                            ...item,
                            user_rating: action.userRating,
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedLoadedList,
            };

        // case allNewsActions.ABORT_NEWS_REQUEST:
        //   return {
        //     ...state,
        //     isFetching: false,
        //   };

        case allNewsActions.CLEAN_NEWS:
            return initialState;

        case allNewsActions.RESET_NEWS_FETCHING:
            return {
                ...state,
                isFetching: false,
            };

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 4+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 5+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/allNews/reducer.js